export default "__VITE_ASSET__BTZGyeKU__"